import { CellClassParams, ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { ActionsCell } from 'core/elements';
import { AgGridDataRow } from 'core/types';

export const getColumnDefs = (
  errors?: any[],
  onRemove?: (index: string | number) => void
): ColDef[] => [
  {
    colId: 'length',
    headerName: t('headerLength'),
    field: 'length',
    cellDataType: 'number',
    cellClass: ({ rowIndex }: CellClassParams) => {
      if (errors && errors[rowIndex] && errors[rowIndex].length) {
        return 'dangerBackground';
      }

      return '';
    },
    valueFormatter: ({ value }) => (Number(value) ? value : DEFAULT_PLACEHOLDER),
  },
  {
    colId: 'quantity',
    headerName: t('headerQuantity'),
    field: 'quantity',
    cellDataType: 'number',
    cellClass: ({ rowIndex }: CellClassParams) => {
      if (errors && errors[rowIndex] && errors[rowIndex].quantity) {
        return 'dangerBackground';
      }

      return '';
    },
    valueFormatter: ({ value }) => (Number(value) ? value : DEFAULT_PLACEHOLDER),
  },
  {
    colId: 'actions',
    width: 40,
    maxWidth: 40,
    pinned: 'right',
    editable: false,
    sortable: false,
    resizable: false,
    lockPinned: true,
    suppressColumnsToolPanel: true,
    headerClass: 'paddingSmall',
    cellClass: 'paddingSmall',
    cellRenderer: ActionsCell,
    cellRendererParams: {
      onRemove: (data: AgGridDataRow) => onRemove(data.id),
    },
  },
];
